import i18n from "../../i18n";
const tr = i18n.t.bind(i18n);
// src/components/shared/dateUtils.js

// Parse to LOCAL Date across formats:
//
// - 'YYYY-MM-DD HH:mm[:ss]' > local
// - ISO without TZ         > local
// - ISO with 'Z' or +00:00 > interpret *clock time* as local (no +3h shift)
export const parseToLocalDate = (val) => {
  if (!val) return new Date(NaN);
  if (val instanceof Date) return val;
  if (typeof val === 'string') {
    const s = val.trim();
    if (s.includes('T')) {
      // explicitly UTC? keep the same wall-clock time in local zone
      if (/Z$|[+-]00:00$/.test(s)) {
        const d = new Date(s);
        return new Date(
          d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(),
          d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()
        );
      }
      // ISO without Z > browser parses as local
      return new Date(s);
    }
    // 'YYYY-MM-DD HH:mm[:ss]' > manual local parse
    const [dpart, tpart = '00:00:00'] = s.split(' ');
    const [Y, M, D] = dpart.split('-').map(Number);
    const [h = 0, m = 0, sec = 0] = tpart.split(':').map((n) => parseInt(n, 10) || 0);
    return new Date(Y, (M || 1) - 1, D || 1, h, m, sec);
  }
  return new Date(val);
};

export const startOfToday = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};
export const endOfToday = () => new Date(startOfToday().getTime() + 24 * 60 * 60 * 1000);

export const isTodayLocal = (val) => {
  const d = parseToLocalDate(val);
  if (isNaN(d)) return false;
  const start = startOfToday();
  const end = endOfToday();
  return d >= start && d < end;
};

// Greek-friendly formatters (safe for any parsed input)
export const formatTimeGR = (val) => {
  const d = parseToLocalDate(val);
  return isNaN(d)
    ? ''
    : d.toLocaleTimeString('el-GR', { hour: '2-digit', minute: '2-digit', hour12: false });
};

export const formatDateTimeGR = (val) => {
  const d = parseToLocalDate(val);
  return isNaN(d)
    ? ''
    : d.toLocaleString('el-GR', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).replace(',', '');
};

// ---- NEW: helpers to produce local 'YYYY-MM-DDTHH:mm' strings (no timezone)
const pad2 = (n) => String(n).padStart(2, '0');

// Round a Date to the next 5-minute slot in LOCAL time (ceil)
export const roundUpTo5MinutesLocal = (d) => {
  const r = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), 0, 0);
  const over = r.getMinutes() % 5;
  if (over !== 0) r.setMinutes(r.getMinutes() + (5 - over));
  return r;
};

// Format a Date as 'YYYY-MM-DDTHH:mm' in LOCAL time (no Z)
export const toLocalIsoMinutes = (d) => {
  return tr('{{var1}}-{{var2}}-{{var3}}T{{var4}}:{{var5}}', {
    var1: d.getFullYear(),
    var2: pad2(d.getMonth()+1),
    var3: pad2(d.getDate()),
    var4: pad2(d.getHours()),
    var5: pad2(d.getMinutes())
  });
};

// Convenience: now, rounded up to next 5' slot, as local ISO minutes
export const nowLocalIso5 = () => toLocalIsoMinutes(roundUpTo5MinutesLocal(new Date()));
